import { render, staticRenderFns } from "./PresetsRaces.vue?vue&type=template&id=2a5f051c&scoped=true"
import script from "./PresetsRaces.vue?vue&type=script&lang=js"
export * from "./PresetsRaces.vue?vue&type=script&lang=js"
import style0 from "./PresetsRaces.vue?vue&type=style&index=0&id=2a5f051c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5f051c",
  null
  
)

export default component.exports